import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { AdminSidebar } from "@/components/sidebars";
import { apiClient, API } from "@/lib/api";

const NAVY = "#132a63";
const GREEN = "#16a34a";

export default function AdminPagos() {
  const [tab, setTab] = useState("afiliado");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    apiClient.get(`/admin/payout-profiles?owner_type=${tab}`).then(({ data }) => setRows(data)).catch(() => {});
  }, [tab]);

  const openDoc = (fileId) => { if (fileId) window.open(`${API}/admin/kyc-file/${fileId}`, "_blank"); };

  return (
    <AppLayout sidebar={AdminSidebar}>
      <header className="app-header"><h1>Pagos y datos fiscales</h1><p className="text-muted">Datos bancarios y documentos para dispersión (SPEI manual)</p></header>

      <div className="panel" style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {[["afiliado", "Socios / Influencers"], ["proveedor", "Proveedores"]].map(([v, l]) => (
          <button key={v} onClick={() => setTab(v)} data-testid={`pagos-tab-${v}`}
            style={{ padding: "8px 16px", borderRadius: 999, border: "none", cursor: "pointer", fontWeight: 700,
              background: tab === v ? NAVY : "#e2e8f0", color: tab === v ? "white" : "#475569" }}>{l}</button>
        ))}
      </div>

      <div className="panel">
        <table className="data-table">
          <thead><tr>
            <th>{tab === "proveedor" ? "Empresa" : "Nombre"}</th><th>Email</th><th>Cuenta</th><th>RFC</th><th>Dir. fiscal</th><th>Docs</th><th>Estado</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`pago-row-${r.id}`}>
                <td><strong>{tab === "proveedor" ? (r.nombre_comercial || r.nombre_fiscal || r.nombre_usuario) : r.nombre_usuario}</strong>{tab === "proveedor" && r.nombre_fiscal ? <div style={{ fontSize: 12, color: "#6b7280" }}>{r.nombre_fiscal}</div> : null}</td>
                <td>{r.email}</td>
                <td>{r.cuenta ? <span>{(r.tipo_cuenta || "clabe").toUpperCase()}<br /><small>{r.cuenta}</small><br /><small>{r.banco} · {r.titular}</small></span> : <span style={{ color: "#b45309" }}>Sin cuenta</span>}</td>
                <td>{r.rfc || "—"}</td>
                <td style={{ maxWidth: 200, fontSize: 12 }}>{r.direccion_fiscal || "—"}</td>
                <td>
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <button className="btn-mini" disabled={!r.documentos?.constancia} onClick={() => openDoc(r.documentos?.constancia?.file_id)} data-testid={`pago-doc-constancia-${r.id}`}>Constancia {r.documentos?.constancia ? "✓" : "—"}</button>
                    <button className="btn-mini" disabled={!r.documentos?.alta} onClick={() => openDoc(r.documentos?.alta?.file_id)} data-testid={`pago-doc-alta-${r.id}`}>Alta SAT {r.documentos?.alta ? "✓" : "—"}</button>
                  </div>
                </td>
                <td><span style={{ fontWeight: 700, color: r.completo ? GREEN : "#b45309" }}>{r.completo ? "Completo" : "Incompleto"}</span></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} style={{ textAlign: "center", color: "#9ca3af", padding: 24 }}>Sin registros aún.</td></tr>}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
